




















import Vue from "vue";
import iwInputNumber from "@/encoding/components/buildingBlocks/InputNumber.vue";

export default Vue.extend({
    components: {
        iwInputNumber: iwInputNumber
    },
    data: function() {
        return {
            pathInStore: "property.specificities.largeEnterprise.availableFloorSurface",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["OFFICE","INDUSTRY","COMMERCIAL", "HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        availableFloorArea: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(availableFloorArea: number): void {
            if (availableFloorArea === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": availableFloorArea});
            }
        }
    },
});
